$(document).on("change", ".itemAmount", function() {
  let total = 0
  $(".itemAmount").each(function() { total += parseInt(this.value) })
  $(".totalAmount").html((total / 100).toFixed(2))
})
